/**
 * Ostoskorin cleanup: poistaa kaiverrus- ja lahjapaketointirivit automaattisesti
 * kun niihin linkitetty paatuote poistuu ostoskorista.
 *
 * Kovakoodatut variant ID:t:
 *   Kaiverruspalvelu:   57340563521913
 *   Lahjapaketointi:    57340762423673
 */
(function () {
  var LINKED_VARIANT_IDS = [57340563521913, 57340762423673];
  var isCleaningUp = false;

  function init() {
    document.addEventListener('on:cart:change', onCartChange);
  }

  async function onCartChange() {
    if (isCleaningUp) return;

    try {
      var resp = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!resp.ok) return;
      var cart = await resp.json();
      await checkAndRemoveOrphanedLinks(cart);
    } catch (e) {
      // hiljainen virhe
    }
  }

  async function checkAndRemoveOrphanedLinks(cart) {
    if (!cart || !cart.items) return;

    var mainProductIds = new Set();
    cart.items.forEach(function (item) {
      if (LINKED_VARIANT_IDS.indexOf(item.variant_id) === -1) {
        mainProductIds.add(String(item.variant_id));
      }
    });

    var orphaned = [];
    cart.items.forEach(function (item) {
      if (LINKED_VARIANT_IDS.indexOf(item.variant_id) === -1) return;
      var linked = item.properties && item.properties._Tuote;
      if (linked && !mainProductIds.has(String(linked))) {
        orphaned.push(item);
      }
    });

    if (orphaned.length > 0) {
      await removeItems(orphaned);
    }
  }

  async function removeItems(items) {
    isCleaningUp = true;

    try {
      var sections = [];
      var sectionEls = [];
      var cartDrawer = document.querySelector('cart-drawer');
      var pageHeader = document.querySelector('page-header');
      var cartForm = document.querySelector('.template-cart cart-form');

      if (cartDrawer && cartDrawer.dataset.sectionId) {
        sections.push(cartDrawer.dataset.sectionId);
        sectionEls.push(cartDrawer);
      }
      if (pageHeader && pageHeader.dataset.sectionId) {
        sections.push(pageHeader.dataset.sectionId);
        sectionEls.push(pageHeader);
      }
      if (cartForm && cartForm.dataset.sectionId) {
        sections.push(cartForm.dataset.sectionId);
        sectionEls.push(cartForm);
      }

      var updates = {};
      items.forEach(function (item) {
        updates[item.key] = 0;
      });

      var resp = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          updates: updates,
          sections: sections.join(','),
          sections_url: window.location.pathname
        })
      });

      if (!resp.ok) return;
      var data = await resp.json();

      if (data.sections) {
        sectionEls.forEach(function (el) {
          var html = data.sections[el.dataset.sectionId];
          if (!html) return;
          if (typeof el.updateFromCartChange === 'function') {
            el.updateFromCartChange(html);
          } else if (typeof el.refreshFromHtml === 'function') {
            el.refreshFromHtml(html);
          }
        });
      }
    } catch (e) {
      // hiljainen virhe
    } finally {
      setTimeout(function () {
        isCleaningUp = false;
      }, 500);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();